export default {
  UPDATE_BY_BRAND: `#graphql
  mutation UpdatePricesByBrand($brand: String!, $percentageNormal: Int!, $percentageClearance: Int) {
    updatePricesByBrand(brand: $brand, percentageNormal: $percentageNormal, percentageClearance: $percentageClearance)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/updatePrices.js